module.exports = __webpack_public_path__ + "static/media/broken-pallet.dc3f26fa.svg";